import { useEffect, useState } from "react";
import { Badge, Box, Code, Flex, Spinner, Text, VStack } from "@chakra-ui/react";
import { adminActionLogs } from "../api";

const actionLabels = {
  USER_STATUS_UPDATE: "유저 상태 변경",
  CAMPAIGN_HIDE: "캠페인 숨김",
  CAMPAIGN_SHOW: "캠페인 노출",
  CAMPAIGN_STATUS_UPDATE: "캠페인 상태 변경",
  ADMIN_PROPOSAL_CONFIRM: "크리에이터 확정",
  CONTENT_CONFIRM: "콘텐츠 승인",
  CONTENT_REJECT: "콘텐츠 반려",
  CONTENT_FEEDBACK: "콘텐츠 피드백",
  LIVE_SCHEDULE_UPDATE: "라이브 일정 변경",
};

const fmtDate = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString("ko-KR", {
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const compactJson = (value) => {
  if (!value) return "-";
  try {
    return JSON.stringify(JSON.parse(value));
  } catch {
    return String(value);
  }
};

export default function AuditLogPreview({ targetType, targetId, title = "관리 이력" }) {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!targetType || !targetId) {
      setLogs([]);
      return;
    }

    let alive = true;
    const load = async () => {
      setLoading(true);
      try {
        const res = await adminActionLogs({
          page: 1,
          size: 5,
          targetType,
          targetId,
        });
        const data = res?.data ?? res;
        if (alive) setLogs(Array.isArray(data?.contents) ? data.contents : []);
      } catch {
        if (alive) setLogs([]);
      } finally {
        if (alive) setLoading(false);
      }
    };

    void load();
    return () => {
      alive = false;
    };
  }, [targetType, targetId]);

  return (
    <Box mt="20px">
      <Text fontSize="14px" fontWeight="700" mb="8px">
        {title}
      </Text>
      <Box border="1px solid #D1D4D9" borderRadius="8px" p="12px">
        {loading ? (
          <Flex justify="center" py="16px">
            <Spinner size="sm" />
          </Flex>
        ) : logs.length === 0 ? (
          <Text color="gray.500" fontSize="13px">
            최근 관리 이력이 없습니다.
          </Text>
        ) : (
          <VStack align="stretch" spacing="10px">
            {logs.map((log, idx) => (
              <Box key={`${log.createdAt}-${log.actionType}-${idx}`}>
                <Flex justify="space-between" gap="8px" mb="4px">
                  <Badge colorScheme="blue">
                    {actionLabels[log.actionType] ?? log.actionType}
                  </Badge>
                  <Text fontSize="12px" color="gray.500">
                    {fmtDate(log.createdAt)}
                  </Text>
                </Flex>
                <Flex gap="6px" fontSize="12px" align="start">
                  <Text color="gray.500" flexShrink={0}>
                    변경
                  </Text>
                  <Code whiteSpace="normal" wordBreak="break-all">
                    {compactJson(log.beforeJson)} → {compactJson(log.afterJson)}
                  </Code>
                </Flex>
              </Box>
            ))}
          </VStack>
        )}
      </Box>
    </Box>
  );
}
